import { render, staticRenderFns } from "./review-setup.vue?vue&type=template&id=212a1ca4&"
import script from "./review-setup.vue?vue&type=script&lang=ts&"
export * from "./review-setup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports